import { getBadges } from "./BrandCard.mjs";
import { BrandLogo } from "../BrandLogo/BrandLogo.mjs";
import { BrandSelectPanel } from "../BrandSelector/BrandSelectPanel/BrandSelectPanel.mjs";
import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { useQuery, useMutation, useApolloClient } from "@apollo/client";
import { useTranslations } from "@vocab/react";
import { Box, Button, IconEdit, IconImage, Actions, Loader, Stack, Text, Secondary, Dialog, useToast, Inline, Badge, Tiles, Notice, Columns, Column, TabsProvider, Tabs, TabPanels, TabPanel, Tab, Alert, IconAdd, ButtonLink, Heading, Hidden, IconArrow, TextLink } from "braid-design-system";
import isEmpty from "lodash/isEmpty.js";
import { useState, useRef, forwardRef, useImperativeHandle, memo, useCallback, useEffect } from "react";
import gql from "graphql-tag";
import { translations } from "../../../components/.vocab/index.mjs";
import { AssetType, coverAspectRatio, BrandStatus } from "@seek/brand-types";
import isNil from "lodash/isNil.js";
import "./Badges/Badges.css.mjs";
import "./Badges/NeedsUpdateBadge.css.mjs";
import { CoverImage } from "../CoverImage/CoverImage.mjs";
import "../CoverImage/CoverImage.css.mjs";
import { root, brandLogo, isError } from "./BrandCard.css.mjs";
import "../BrandSelector/BrandSelectPanel/BrandSelectPanel.css.mjs";
import { FileUploader } from "../private/FileUploader/FileUploader.mjs";
import "../UploadAssetButton/UploadAssetButton.css.mjs";
import "../../../components/CompanyProfileCarousel/hooks/usePaginationAriaLabel/.vocab/index.mjs";
import { adapter } from "@seek/tealium-adapter";
import "../CompanyProfileCarousel/components/BulletPoints/BulletPoints.css.mjs";
import "../CompanyProfileCarousel/components/CompanyProfileCards/CompanyProfileCards.mjs";
import "../CompanyProfileCarousel/components/Carousel/Carousel.css.mjs";
import "../CompanyProfileCarousel/components/Placeholder/Placeholder.css.mjs";
import { StrategiesEnum, SUPPORTED_IMAGE_FORMATS, FILE_SIZE_LIMIT } from "@seek/image-service-types";
import forEach from "lodash/forEach.js";
import "../SegmentedButtonSelector/SegmentedButtonSelector.css.mjs";
import "../BrandLogo/Logo/Logo.css.mjs";
import "../BrandLogo/BrandLogo.css.mjs";
import "../private/FileUploader/FileUploader.css.mjs";
import Cropper from "react-cropper";
import { UploadAssetButton as UploadAssetButton$1 } from "../UploadAssetButton/UploadAssetButton.mjs";
import compact from "lodash/compact.js";
import sortBy from "lodash/sortBy.js";
import uniqBy from "lodash/uniqBy.js";
import { MAX_ITEMS_FOR_NEW_HOMEPAGE_LAYOUT, MAX_ITEMS, MAX_ITEMS_PER_SLIDE_FOR_NEW_HOMEPAGE_LAYOUT, MAX_ITEMS_PER_SLIDE, Carousel } from "../CompanyProfileCarousel/components/Carousel/Carousel.mjs";
import { Placeholder } from "../CompanyProfileCarousel/components/Placeholder/Placeholder.mjs";
import { getSiteFromZoneAndProduct, createUrlResolver, isMelwaysZone } from "@seek/melways-sites";
import "../SegmentedButtonSelector/SegmentedButtonSelector.mjs";
const AddAssetButton = ({
  label,
  dataTestId = "bx-add-asset",
  onClick,
  children,
  isReplaceButton
}) => /* @__PURE__ */ jsxs(Box, { position: "relative", display: "flex", flexDirection: ["column", "row"], children: [
  /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
    Button,
    {
      onClick,
      data: { testid: dataTestId },
      variant: isReplaceButton ? "soft" : "solid",
      children: /* @__PURE__ */ jsxs(Box, { style: { whiteSpace: "nowrap" }, children: [
        isReplaceButton ? /* @__PURE__ */ jsx(IconEdit, {}) : /* @__PURE__ */ jsx(IconImage, {}),
        /* @__PURE__ */ jsx(Box, { display: "inlineBlock", marginRight: "xsmall" }),
        label
      ] })
    }
  ) }),
  children
] });
const AssetsFragment = gql`
  fragment assetFields on BrandAssets {
    logo {
      id
      url
      strategies
    }
    cover {
      id
      url
      strategies
    }
  }
`;
const BrandDetailsFragment = gql`
  fragment brandDetails on Brand {
    id
    legacyId
    owner {
      id
      type
    }
    name
    state
    isDefault
    isLiveOnAd
    createdOn
    assets {
      ...assetFields
    }
  }
  ${AssetsFragment}
`;
const ListBrandsQuery = gql`
  query ListBrands {
    brands {
      ...brandDetails
    }
  }
  ${BrandDetailsFragment}
`;
const BrandingAssetsQuery = gql`
  query BrandingAssets($input: GetBrandingAssetsInput!) {
    brandingAssets(input: $input) {
      id
      url
      isDeletable
      isLiveOnAd
      isOnDefaultBrand
      numberOfLiveAds
      numberOfBrands
      strategies {
        ... on LogoStrategies {
          serpLogo
          jdpLogo
        }
        ... on CoverStrategies {
          jdpCoverThumbnail
          jdpCover
        }
      }
    }
  }
`;
const IsImagePublishedQuery = gql`
  query IsImagePublished($imageId: String!) {
    isImagePublished(id: $imageId)
  }
`;
const BrandUpdateMutationFragment = gql`
  fragment updateBrandDetailsFragment on UpdateBrandPayload {
    ... on UpdateBrandSuccessPayload {
      id
      legacyId
      owner {
        id
        type
      }
      name
      state
      isDefault
      assets {
        ...assetFields
      }
    }
    ... on InvalidInputPayload {
      reason
    }
  }
  ${AssetsFragment}
`;
const BrandCreateMutationFragment = gql`
  fragment createBrandDetailsFragment on CreateBrandPayload {
    ... on CreateBrandSuccessPayload {
      id
      legacyId
      owner {
        id
        type
      }
      name
      state
      isDefault
      assets {
        ...assetFields
      }
    }
    ... on InvalidInputPayload {
      reason
    }
  }
  ${AssetsFragment}
`;
const CreateBrandMutation = gql`
  mutation createBrand($input: CreateBrandInput!) {
    createBrand(input: $input) {
      ...createBrandDetailsFragment
    }
  }
  ${BrandCreateMutationFragment}
`;
const UpdateBrandMutation = gql`
  mutation updateBrand($input: UpdateBrandInput!) {
    updateBrand(input: $input) {
      ...updateBrandDetailsFragment
    }
  }
  ${BrandUpdateMutationFragment}
`;
const extractCoverAsset = (data) => {
  var _a;
  if (data.croppedCoverInfo.dataUrl) {
    return {
      displayUrl: data.croppedCoverInfo.dataUrl,
      originalUrl: (_a = data.coverAsset) == null ? void 0 : _a.url,
      asset: data.coverAsset
    };
  }
  if (data.file) {
    return {
      displayUrl: URL.createObjectURL(data.file),
      originalUrl: URL.createObjectURL(data.file)
    };
  }
  if (data.coverAsset) {
    return {
      displayUrl: data.coverAsset.strategies.jdpCover,
      originalUrl: data.coverAsset.url,
      asset: data.coverAsset
    };
  }
  return {};
};
const extractLogoAsset = (data) => {
  if (data.file) {
    return {
      displayUrl: URL.createObjectURL(data.file),
      originalUrl: URL.createObjectURL(data.file)
    };
  }
  if (data.logoAsset) {
    return {
      displayUrl: data.logoAsset.strategies.jdpLogo,
      originalUrl: data.logoAsset.url,
      asset: data.logoAsset
    };
  }
  return {};
};
const logoStrategies = [
  StrategiesEnum.JDP_LOGO,
  StrategiesEnum.SERP_LOGO,
  StrategiesEnum.SERP_LOGO_LEGACY
];
const legacyCoverStrategies = [StrategiesEnum.JDP_COVER_MOBILE_SMALL_LEGACY];
const coverStrategies = [
  StrategiesEnum.JDP_COVER_LEGACY,
  StrategiesEnum.JDP_COVER,
  StrategiesEnum.JDP_COVER_THUMBNAIL
];
const getAssetStrategies = (type, croppedInfo) => {
  if (type === AssetType.LOGO) {
    return logoStrategies.map((strategyName) => ({ name: strategyName }));
  } else if (type === AssetType.COVER) {
    return [
      ...legacyCoverStrategies.map((strategyName) => ({
        name: strategyName
      })),
      ...coverStrategies.map((name) => ({
        name,
        ...croppedInfo
      }))
    ];
  }
  return [];
};
const getImageServiceEndpoint = ({ isProd }) => `https://image-service-api${isProd ? "" : ".staging"}.cloud.seek.com.au/client`;
const formatToken = (token) => /^Bearer .*/.test(token) ? token : `Bearer ${token}`;
var Usage = /* @__PURE__ */ ((Usage2) => {
  Usage2["logo"] = "logo";
  Usage2["cover"] = "cover";
  return Usage2;
})(Usage || {});
const uploadAsset = async ({
  image,
  getToken,
  isProd,
  strategies,
  usage,
  id
}) => {
  const token = getToken && await getToken();
  if (!token) {
    throw new Error("Failed to get token");
  }
  const urlId = id ? `/${id}` : "";
  const formData = new FormData();
  const uploadParams = id ? {
    ...strategies ? { strategies: JSON.stringify(strategies) } : {}
  } : {
    image,
    ...usage ? { metadata: JSON.stringify({ usage }) } : {},
    ...strategies ? { strategies: JSON.stringify(strategies) } : {}
  };
  forEach(uploadParams, (value, key) => value && formData.append(key, value));
  const response = await fetch(
    `${getImageServiceEndpoint({ isProd })}${urlId}`,
    {
      method: id ? "PATCH" : "POST",
      headers: {
        Authorization: formatToken(token)
      },
      body: formData
    }
  );
  const respBody = await (response == null ? void 0 : response.json());
  if (!response.ok) {
    const respStatus = response == null ? void 0 : response.status;
    const respMessage = respStatus === 400 ? respBody == null ? void 0 : respBody.message : "";
    throw new Error(respMessage || "Failed to upload image");
  }
  return respBody;
};
const uploadCover = async ({
  image,
  getToken,
  isProd,
  croppedInfo,
  id
}) => uploadAsset({
  image,
  getToken,
  isProd,
  strategies: getAssetStrategies(AssetType.COVER, croppedInfo),
  usage: Usage.cover,
  id
});
const ButtonGroup = ({
  cancelText,
  successText,
  onSuccess,
  onCancel,
  loading = false
}) => /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Actions, { children: [
  /* @__PURE__ */ jsx(
    Button,
    {
      loading,
      onClick: onSuccess,
      data: { testid: "successButton" },
      children: successText
    }
  ),
  /* @__PURE__ */ jsx(Button, { variant: "ghost", onClick: onCancel, children: cancelText })
] }) });
const PageLoader = () => /* @__PURE__ */ jsx(
  Box,
  {
    padding: ["large", "xxlarge"],
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "full",
    "data-testid": "page-loader",
    children: /* @__PURE__ */ jsx(Loader, {})
  }
);
const ImageCropper = ({ src, onReady }) => {
  const [loading, setLoading] = useState(true);
  const cropperRef = useRef(null);
  const onCropperReady = () => {
    var _a;
    if (cropperRef.current) {
      setLoading(false);
      onReady((_a = cropperRef == null ? void 0 : cropperRef.current) == null ? void 0 : _a.cropper);
    }
  };
  return /* @__PURE__ */ jsxs(Box, { "data-testid": "image-cropper", children: [
    loading && /* @__PURE__ */ jsx(PageLoader, {}),
    /* @__PURE__ */ jsx(
      Cropper,
      {
        viewMode: 1,
        ref: cropperRef,
        zoomable: false,
        src,
        style: {
          height: 350,
          width: "100%"
        },
        guides: false,
        autoCropArea: 1,
        initialAspectRatio: coverAspectRatio,
        aspectRatio: coverAspectRatio,
        rotatable: false,
        toggleDragModeOnDblclick: false,
        ready: onCropperReady,
        minCropBoxWidth: 100,
        minCropBoxHeight: 100
      }
    )
  ] });
};
const CoverCropper = ({
  src,
  onClose,
  onSave,
  croppedBoxData
}) => {
  const cropperRef = useRef();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslations(translations);
  const onReady = (newCropper) => {
    cropperRef.current = newCropper;
    if (croppedBoxData) {
      cropperRef.current.setCropBoxData(croppedBoxData);
    }
  };
  const onSaveClick = () => {
    if (cropperRef.current) {
      setLoading(true);
      cropperRef.current.getCroppedCanvas().toBlob((blob) => {
        var _a, _b;
        if (blob) {
          const image = {
            dataUrl: URL.createObjectURL(blob),
            data: (_a = cropperRef.current) == null ? void 0 : _a.getData(true),
            croppedBoxData: (_b = cropperRef.current) == null ? void 0 : _b.getCropBoxData()
          };
          onSave(image);
        }
      }, "image/jpeg");
    }
  };
  return /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
    /* @__PURE__ */ jsxs(Stack, { space: "small", children: [
      /* @__PURE__ */ jsx(Box, { display: "flex", justifyContent: "center", children: /* @__PURE__ */ jsx(Text, { children: /* @__PURE__ */ jsx(Secondary, { children: t("Drag to move cover image") }) }) }),
      /* @__PURE__ */ jsx(ImageCropper, { src, onReady })
    ] }),
    /* @__PURE__ */ jsx(
      ButtonGroup,
      {
        cancelText: t("Cancel"),
        successText: t("Preview"),
        onSuccess: onSaveClick,
        loading,
        onCancel: onClose
      }
    )
  ] });
};
const CoverCropperModal = ({
  isOpen,
  onClose,
  onSave,
  src,
  title,
  croppedBoxData
}) => /* @__PURE__ */ jsx(Dialog, { id: "CoverCropperModal", open: isOpen, onClose, title, children: isOpen && /* @__PURE__ */ jsx(
  CoverCropper,
  {
    src,
    croppedBoxData,
    onClose,
    onSave
  }
) });
const CoverCropperContainer = ({
  isOpen,
  title,
  asset,
  getToken,
  isProd,
  onSave,
  onClose,
  onCoverImageUploadSuccess,
  onCoverImageUploadFailed
}) => {
  const { originalUrl: src } = extractCoverAsset(asset);
  const isNewCoverImage = Boolean(asset.file);
  const showToast = useToast();
  const { t } = useTranslations(translations);
  const handleOnSave = async (image) => {
    var _a;
    if (onSave && getToken) {
      try {
        const response = isNewCoverImage ? await uploadCover({
          image: asset.file,
          getToken,
          isProd,
          croppedInfo: image.data
        }) : await uploadCover({
          id: (_a = asset.coverAsset) == null ? void 0 : _a.id,
          getToken,
          isProd,
          croppedInfo: image.data
        });
        onSave({
          coverAsset: response,
          file: asset.file,
          croppedCoverInfo: image
        });
        if (isNewCoverImage && onCoverImageUploadSuccess) {
          onCoverImageUploadSuccess();
        }
      } catch {
        showToast({
          tone: "critical",
          message: t("Oops!"),
          description: t(
            "Something went wrong! Please try again or contact customer support."
          )
        });
        if (onCoverImageUploadFailed) {
          onCoverImageUploadFailed();
        }
      }
    }
  };
  if (!src) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    CoverCropperModal,
    {
      isOpen,
      onClose,
      onSave: handleOnSave,
      title,
      src,
      croppedBoxData: asset.croppedCoverInfo.croppedBoxData
    }
  );
};
const AssetLibraryItem = ({
  asset,
  assetType,
  isSelected,
  onAssetClick
}) => {
  const isLogo = assetType === AssetType.LOGO;
  const { t } = useTranslations(translations);
  const overlayElementsSideSpacing = "xsmall";
  const badges = getBadges({
    isDefault: Boolean(asset.isOnDefaultBrand),
    isLiveOnAd: Boolean(asset.isLiveOnAd)
  });
  return /* @__PURE__ */ jsxs(
    Box,
    {
      onClick: () => onAssetClick(asset),
      "data-testid": "bx-asset-library-item",
      position: "relative",
      children: [
        badges.length > 0 && /* @__PURE__ */ jsx(
          Box,
          {
            position: "absolute",
            marginTop: overlayElementsSideSpacing,
            marginLeft: overlayElementsSideSpacing,
            zIndex: 1,
            children: badges && /* @__PURE__ */ jsx(Inline, { space: "xsmall", children: badges.map((badge) => /* @__PURE__ */ jsx(
              Badge,
              {
                id: badge.id,
                weight: "strong",
                tone: badge.tone,
                children: t(badge.children)
              },
              `bx-brand-asset-badge-${badge.id}`
            )) })
          }
        ),
        isLogo ? /* @__PURE__ */ jsx(
          BrandLogo,
          {
            logo: asset,
            selectable: true,
            placement: "assetLibrary",
            selected: isSelected
          }
        ) : /* @__PURE__ */ jsx(
          CoverImage,
          {
            cover: asset,
            showThumbnail: true,
            selectable: true,
            selected: isSelected
          }
        )
      ]
    }
  );
};
const isImageTypeSupported = (filename) => {
  const fileExtension = filename.toLowerCase().split(".").pop();
  return SUPPORTED_IMAGE_FORMATS.includes(fileExtension);
};
const bytesToMB = (bytes) => bytes / 1024 / 1024;
const LOGO_FILE_SIZE_LIMIT = 5242880;
const AssetLibraryUploadButton = ({
  assetType,
  onFileSelected
}) => {
  const showToast = useToast();
  const fileSizeValidation = {
    [AssetType.LOGO]: LOGO_FILE_SIZE_LIMIT,
    [AssetType.COVER]: FILE_SIZE_LIMIT
  }[assetType];
  const { t } = useTranslations(translations);
  const label = assetType === AssetType.LOGO ? t("Upload logo") : t("Upload cover image");
  const onSelected = (file) => {
    if (file.size > fileSizeValidation) {
      showToast({
        tone: "critical",
        message: t("Oops!"),
        description: t("The image file is too big", {
          assetType,
          fileSize: bytesToMB(fileSizeValidation).toString()
        })
      });
      return;
    }
    if (!isImageTypeSupported(file.name)) {
      showToast({
        tone: "critical",
        message: t(`Sorry, this file type cannot be uploaded`),
        description: t(
          "Accepted file formats: .jpeg, .jpg, .png, .webp, .tiff, .gif, .svg"
        )
      });
      return;
    }
    onFileSelected(file);
  };
  return /* @__PURE__ */ jsx(UploadAssetButton$1, { label, onFileSelected: onSelected });
};
const AssetLibrary = ({
  assets,
  assetType,
  selectedAsset,
  onCancel,
  onSave,
  onFileSelected,
  onAssetClicked
}) => {
  const { t } = useTranslations(translations);
  return /* @__PURE__ */ jsxs(Stack, { space: "large", children: [
    /* @__PURE__ */ jsx(Box, { overflow: "auto", style: { maxHeight: "50vh", margin: "0 -24px" }, children: /* @__PURE__ */ jsx(Box, { paddingX: "gutter", children: /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
      /* @__PURE__ */ jsx(
        AssetLibraryUploadButton,
        {
          assetType,
          onFileSelected
        }
      ),
      /* @__PURE__ */ jsx(Tiles, { columns: 4, space: "gutter", children: assets.map((asset) => /* @__PURE__ */ jsx(
        AssetLibraryItem,
        {
          assetType,
          asset,
          isSelected: Boolean((selectedAsset == null ? void 0 : selectedAsset.id) === asset.id),
          onAssetClick: onAssetClicked
        },
        `asset-library-item-${asset.id}`
      )) })
    ] }) }) }),
    /* @__PURE__ */ jsx(
      ButtonGroup,
      {
        successText: t("Select"),
        cancelText: t("Cancel"),
        onSuccess: selectedAsset ? onSave : onCancel,
        onCancel
      }
    )
  ] });
};
const AssetLibraryModal = ({
  assets,
  title,
  isOpen,
  assetType,
  selectedAsset,
  onClose,
  onSave,
  onFileSelected,
  onAssetSelected
}) => /* @__PURE__ */ jsx(
  Dialog,
  {
    id: "AssetLibraryModal",
    open: isOpen,
    onClose,
    title,
    width: "medium",
    children: isOpen && /* @__PURE__ */ jsx(
      AssetLibrary,
      {
        assets,
        assetType,
        onCancel: onClose,
        onSave,
        onFileSelected,
        onAssetClicked: onAssetSelected,
        selectedAsset
      }
    )
  }
);
const AssetLibraryContainer = ({
  isOpen,
  assetType,
  isProd,
  onClose,
  onLogoSaved,
  onCoverSaved,
  onCoverImageUploadSuccess,
  onCoverImageUploadFailed,
  getToken
}) => {
  const initialCropperAsset = {
    croppedCoverInfo: {}
  };
  const { t } = useTranslations(translations);
  const [isCropperOpen, setIsCropperOpen] = useState(false);
  const [cropperAsset, setCropperAsset] = useState(initialCropperAsset);
  const [selectedAsset, setSelectedAsset] = useState(
    void 0
  );
  const showToast = useToast();
  const { data, loading } = useQuery(BrandingAssetsQuery, {
    variables: {
      input: {
        assetType
      }
    },
    fetchPolicy: "network-only"
  });
  const handleOnSave = () => {
    if (assetType === AssetType.LOGO && onLogoSaved) {
      onLogoSaved({ logoAsset: selectedAsset });
    }
    if (assetType === AssetType.COVER && onCoverSaved) {
      onCoverSaved({ coverAsset: selectedAsset, croppedCoverInfo: {} });
    }
    onClose();
  };
  const handleOnFileSelected = async (file) => {
    if (assetType === AssetType.LOGO && onLogoSaved && getToken) {
      try {
        const response = await uploadLogo({
          image: file,
          getToken,
          isProd
        });
        onLogoSaved({ logoAsset: response, file });
        onClose();
      } catch {
        showToast({
          tone: "critical",
          message: t("Oops!"),
          description: t(
            "Something went wrong! Please try again or contact customer support."
          )
        });
      }
    }
    if (assetType === AssetType.COVER) {
      setCropperAsset({ ...cropperAsset, file });
      setIsCropperOpen(true);
    }
  };
  const handleOnCoverImageUploadFailed = () => {
    if (onCoverImageUploadFailed) {
      onCoverImageUploadFailed();
    }
    setIsCropperOpen(false);
  };
  const handleCropperOnSave = (asset) => {
    setIsCropperOpen(false);
    onClose();
    if (onCoverSaved) {
      onCoverSaved(asset);
    }
  };
  if (loading) {
    return /* @__PURE__ */ jsx(PageLoader, {});
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      AssetLibraryModal,
      {
        assets: (data == null ? void 0 : data.brandingAssets) ?? [],
        title: assetType === AssetType.COVER ? "Select Cover Image" : "Select Logo Image",
        isOpen,
        assetType,
        onClose,
        selectedAsset,
        onSave: handleOnSave,
        onFileSelected: handleOnFileSelected,
        onAssetSelected: setSelectedAsset
      }
    ),
    /* @__PURE__ */ jsx(
      CoverCropperContainer,
      {
        isOpen: isCropperOpen,
        asset: cropperAsset,
        title: t("Adjust cover image"),
        isProd,
        getToken,
        onClose: () => {
          setCropperAsset(initialCropperAsset);
        },
        onSave: handleCropperOnSave,
        onCoverImageUploadSuccess,
        onCoverImageUploadFailed: handleOnCoverImageUploadFailed
      }
    )
  ] });
};
const BrandCardWithAssetLibrary = forwardRef(
  ({
    showCoverImage = true,
    showAddCoverImageButton,
    showCoverImageText,
    coverPlaceholderText,
    isProd,
    getToken,
    onBrandSavedHook,
    onAddLogoClick,
    onReplaceLogoClick,
    onNewBrandUpdated,
    onAddCoverClick,
    onCoverImageSaved,
    onReplaceCoverClick,
    onRepositionCoverClick,
    onRemoveCoverClick,
    onCoverImageUploadSuccess,
    onBrandSelected,
    onCoverImageUploadFailed
  }, ref) => {
    const [brand, setBrand] = useState(void 0);
    const { id } = brand || {};
    const isUpdateMutation = Boolean(id);
    const saveBrandMutation = isUpdateMutation ? UpdateBrandMutation : CreateBrandMutation;
    const [saveBrand] = useMutation(saveBrandMutation);
    const { t } = useTranslations(translations);
    const showToast = useToast();
    const [isAssetLibraryOpen, setIsAssetLibraryOpen] = useState(false);
    const [assetLibraryAssetType, setAssetLibraryAssetType] = useState(AssetType.LOGO);
    const [coverAsset, setCoverAsset] = useState({
      croppedCoverInfo: {}
    });
    const [logoAsset, setLogoAsset] = useState({});
    const [isCropperOpen, setIsCropperOpen] = useState(false);
    const [shouldShowCoverOnlyError, setShouldShowCoverOnlyError] = useState(false);
    const { displayUrl: coverUrl } = extractCoverAsset(coverAsset);
    const { displayUrl: logoUrl } = extractLogoAsset(logoAsset);
    useImperativeHandle(ref, () => ({
      handleValidation: () => {
        if (!shouldShowCoverOnlyError) {
          return null;
        }
        return "Error: A logo must be added with your cover image";
      }
    }));
    const handleOnCoverSaved = async (asset) => {
      if ((logoAsset == null ? void 0 : logoAsset.logoAsset) && (asset == null ? void 0 : asset.coverAsset) && isUpdateMutation) {
        const isSuccess = await upsertBrand(
          logoAsset.logoAsset,
          asset == null ? void 0 : asset.coverAsset
        );
        if (isSuccess) {
          setShouldShowCoverOnlyError(false);
          setCoverAsset(asset);
        }
      } else {
        setShouldShowCoverOnlyError(true);
        if (onBrandSelected) {
          onBrandSelected({
            error: new Error("A logo must be added with your cover image")
          });
        }
        setCoverAsset(asset);
      }
      onCoverImageSaved == null ? void 0 : onCoverImageSaved({ isNewCoverImage: Boolean(asset == null ? void 0 : asset.file) });
      setIsCropperOpen(false);
    };
    const onLogoFileSelected = async (file) => {
      if (getToken) {
        try {
          const response = await uploadLogo({
            image: file,
            getToken,
            isProd
          });
          const isSuccess = await upsertBrand(response, coverAsset == null ? void 0 : coverAsset.coverAsset);
          if (isSuccess) {
            setShouldShowCoverOnlyError(false);
            setLogoAsset({ logoAsset: response, file });
          }
        } catch {
          showToast({
            tone: "critical",
            message: t("Oops!"),
            description: t(
              "Something went wrong! Please try again or contact customer support."
            )
          });
        }
      }
    };
    const handleOnLogoSaved = async (asset) => {
      if (asset.logoAsset) {
        const isSuccess = await upsertBrand(
          asset.logoAsset,
          coverAsset == null ? void 0 : coverAsset.coverAsset
        );
        if (isSuccess) {
          setShouldShowCoverOnlyError(false);
          setLogoAsset(asset);
        }
      } else {
        setLogoAsset(asset);
      }
    };
    const upsertBrand = async (logo, cover) => {
      try {
        const response = await saveBrand({
          variables: {
            input: {
              ...isUpdateMutation ? { id } : {},
              assets: {
                logo: {
                  id: logo == null ? void 0 : logo.id,
                  url: logo == null ? void 0 : logo.url,
                  strategies: logo == null ? void 0 : logo.strategies
                },
                ...cover ? {
                  cover: {
                    id: cover == null ? void 0 : cover.id,
                    url: cover == null ? void 0 : cover.url,
                    strategies: cover == null ? void 0 : cover.strategies
                  }
                } : {}
              }
            }
          }
        });
        const newBrand = isUpdateMutation ? response.data.updateBrand : response.data.createBrand;
        setBrand(newBrand);
        onBrandSavedHook({ data: newBrand });
        if (onNewBrandUpdated) {
          onNewBrandUpdated({ isCreated: !isUpdateMutation });
        }
        return true;
      } catch {
        showToast({
          tone: "critical",
          message: t("Oops!"),
          description: t(
            "Something went wrong! Please try again or contact customer support."
          )
        });
        return false;
      }
    };
    const handleOnAddCoverClicked = () => {
      setAssetLibraryAssetType(AssetType.COVER);
      setIsAssetLibraryOpen(true);
      if (onAddCoverClick) {
        onAddCoverClick();
      }
    };
    const handleOnAddLogoClicked = () => {
      if (isNil(logoAsset) && onAddLogoClick) {
        onAddLogoClick();
      }
      if (!isNil(logoAsset) && onReplaceLogoClick) {
        onReplaceLogoClick();
      }
    };
    const handleOnReplaceCoverClicked = () => {
      setAssetLibraryAssetType(AssetType.COVER);
      setIsAssetLibraryOpen(true);
      if (onReplaceCoverClick) {
        onReplaceCoverClick();
      }
    };
    const handleOnRepositionCoverClicked = () => {
      setIsCropperOpen(true);
      if (onRepositionCoverClick) {
        onRepositionCoverClick();
      }
    };
    const handleOnRemoveCoverClicked = () => {
      setCoverAsset({ croppedCoverInfo: {} });
      setShouldShowCoverOnlyError(false);
      if (onRemoveCoverClick) {
        onRemoveCoverClick();
      }
    };
    const handleOnCoverImageUploadFailed = () => {
      if (onCoverImageUploadFailed) {
        onCoverImageUploadFailed();
      }
      setIsCropperOpen(false);
    };
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      showCoverImage ? /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
        /* @__PURE__ */ jsxs(
          Box,
          {
            className: [
              root,
              {
                [isError]: shouldShowCoverOnlyError
              }
            ],
            "data-testid": `bx-brand-card-${id}`,
            children: [
              showCoverImage && /* @__PURE__ */ jsx(
                CoverImage,
                {
                  directCoverUrl: coverUrl,
                  showThumbnail: true,
                  isEditMode: showAddCoverImageButton,
                  showCoverImageText,
                  coverPlaceholderText,
                  isLightTheme: true,
                  onAddCoverClick: handleOnAddCoverClicked,
                  onReplaceCoverClick: handleOnReplaceCoverClicked,
                  onRepositionCoverClick: handleOnRepositionCoverClicked,
                  onRemoveCoverClick: handleOnRemoveCoverClicked
                }
              ),
              /* @__PURE__ */ jsx(Box, { background: "surface", paddingX: "gutter", paddingY: "medium", children: /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
                Boolean(logoUrl) && /* @__PURE__ */ jsx(Box, { className: brandLogo, children: /* @__PURE__ */ jsx(BrandLogo, { directUrl: logoUrl }) }),
                /* @__PURE__ */ jsx(
                  AddAssetButton,
                  {
                    label: !logoUrl ? t("Add logo") : t("Replace logo"),
                    onClick: handleOnAddLogoClicked,
                    isReplaceButton: Boolean(logoUrl),
                    children: /* @__PURE__ */ jsx(FileUploader, { onFileSelected: onLogoFileSelected })
                  }
                )
              ] }) })
            ]
          }
        ),
        shouldShowCoverOnlyError && /* @__PURE__ */ jsx(Notice, { tone: "critical", children: /* @__PURE__ */ jsx(Text, { children: t("A logo must be added with your cover image") }) })
      ] }) : /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
        Boolean(logoUrl) && /* @__PURE__ */ jsx(Box, { className: brandLogo, children: /* @__PURE__ */ jsx(BrandLogo, { directUrl: logoUrl }) }),
        /* @__PURE__ */ jsx(
          AddAssetButton,
          {
            label: !logoUrl ? t("Add logo") : t("Replace logo"),
            onClick: handleOnAddLogoClicked,
            isReplaceButton: Boolean(logoUrl),
            children: /* @__PURE__ */ jsx(FileUploader, { onFileSelected: onLogoFileSelected })
          }
        )
      ] }),
      /* @__PURE__ */ jsx(
        AssetLibraryContainer,
        {
          isOpen: isAssetLibraryOpen,
          assetType: assetLibraryAssetType,
          onClose: () => setIsAssetLibraryOpen(false),
          onCoverSaved: handleOnCoverSaved,
          onLogoSaved: handleOnLogoSaved,
          onCoverImageUploadSuccess,
          onCoverImageUploadFailed,
          getToken,
          isProd
        }
      ),
      /* @__PURE__ */ jsx(
        CoverCropperContainer,
        {
          isOpen: isCropperOpen,
          asset: coverAsset,
          title: t("Adjust cover image"),
          isProd,
          getToken,
          onClose: () => {
            setIsCropperOpen(false);
          },
          onSave: handleOnCoverSaved,
          onCoverImageUploadFailed: handleOnCoverImageUploadFailed
        }
      )
    ] });
  }
);
const CreateBrandPanel = memo(
  forwardRef(
    ({
      getToken,
      isProd,
      showCoverImage = true,
      showCoverImageText,
      coverPlaceholderText,
      showAddCoverImageButton,
      onBrandSavedHook,
      onAddLogoClick,
      onCoverImageSaved,
      onReplaceLogoClick,
      onNewBrandUpdated,
      onAddCoverClick,
      onReplaceCoverClick,
      onRepositionCoverClick,
      onRemoveCoverClick,
      onCoverImageUploadSuccess,
      onBrandSelected,
      onCoverImageUploadFailed
    }, ref) => /* @__PURE__ */ jsx(Columns, { space: "small", collapseBelow: "tablet", children: /* @__PURE__ */ jsx(Column, { width: "1/2", children: /* @__PURE__ */ jsx(
      BrandCardWithAssetLibrary,
      {
        showCoverImage,
        showAddCoverImageButton,
        isProd,
        showCoverImageText,
        coverPlaceholderText,
        getToken,
        onBrandSavedHook,
        onAddLogoClick,
        onReplaceLogoClick,
        onNewBrandUpdated,
        onAddCoverClick,
        onCoverImageSaved,
        onReplaceCoverClick,
        onRepositionCoverClick,
        onRemoveCoverClick,
        onCoverImageUploadSuccess,
        onBrandSelected,
        onCoverImageUploadFailed,
        ref
      }
    ) }) })
  ),
  (prevProps, nextProps) => (
    // Compare props that should trigger a rerender
    prevProps.showCoverImage === nextProps.showCoverImage && prevProps.showAddCoverImageButton === nextProps.showAddCoverImageButton && prevProps.isProd === nextProps.isProd && prevProps.showCoverImageText === nextProps.showCoverImageText && prevProps.coverPlaceholderText === nextProps.coverPlaceholderText
  )
);
const BxTabs = ({ tabs }) => {
  const renderTab = (tab) => /* @__PURE__ */ jsx(Tab, { children: /* @__PURE__ */ jsx(Box, { padding: "none", cursor: "pointer", onClick: tab.onClick, children: tab.text }) }, tab.text);
  return /* @__PURE__ */ jsx(TabsProvider, { id: "brand-selector-tabs", children: /* @__PURE__ */ jsxs(Stack, { space: "large", children: [
    /* @__PURE__ */ jsx(Tabs, { label: "brandActionTabs", children: tabs.map(renderTab) }),
    /* @__PURE__ */ jsx(TabPanels, { renderInactivePanels: true, children: tabs.map((tab) => /* @__PURE__ */ jsx(TabPanel, { children: tab.PanelContent }, tab.text)) })
  ] }) });
};
const getBrandsToShow = ({
  brands = [],
  brandId,
  legacyId,
  limit
}) => {
  const defaultBrand = brands.find((brand) => brand.isDefault === true);
  const activeNonDefaultBrands = brands.filter(
    ({ state, isDefault }) => state === BrandStatus.ACTIVE && !isDefault
  );
  const existingBrandId = brandId || legacyId;
  const existingAttachedBrand = existingBrandId ? activeNonDefaultBrands.find(
    (brand) => brand.id === existingBrandId || brand.legacyId === legacyId
  ) : void 0;
  const activeBrands = sortBy(activeNonDefaultBrands, "createdOn").reverse();
  const brandsSequence = compact([
    existingAttachedBrand,
    defaultBrand,
    ...activeBrands
  ]);
  const uniqueBrands = uniqBy(brandsSequence, "id");
  const result = limit ? uniqueBrands.splice(0, limit) : uniqueBrands;
  return result.map((b, index) => ({ ...b, position: index + 1 }));
};
const BrandSelector = forwardRef(
  ({
    onBrandSelected,
    brandId,
    legacyId,
    limit,
    getToken,
    isProd,
    showCoverImage = true,
    showAddCoverImageButton = true,
    showCoverImageText = false,
    descriptionAtTop = "",
    showBrandId = false,
    showName = false,
    tileRowCount = 2,
    coverPlaceholderText,
    // tracking callbacks
    onBrandsLoaded,
    onSelectBrandTabClick,
    onCreateBrandTabClick,
    onNewBrandUpdated,
    onAddLogoClick,
    onReplaceLogoClick,
    onAddCoverClick,
    onCoverImageSaved,
    onReplaceCoverClick,
    onRepositionCoverClick,
    onRemoveCoverClick,
    onCoverImageUploadSuccess,
    onCoverImageUploadFailed
  }, ref) => {
    const [selectedBrandId, setSelectedBrandId] = useState("");
    const [createdBrand, setCreatedBrand] = useState();
    const [brands, setBrands] = useState([]);
    const hasBrands = !isEmpty(brands);
    const [isSelecting, setIsSelecting] = useState(true);
    const { t } = useTranslations(translations);
    const { data, error, loading } = useQuery(ListBrandsQuery, {
      skip: hasBrands,
      fetchPolicy: "no-cache"
    });
    const resetToFirstExisting = useCallback(() => {
      const initiallySelectedBrand = brands[0];
      setSelectedBrandId(initiallySelectedBrand.id);
      onBrandSelected({ data: initiallySelectedBrand });
    }, [brands, onBrandSelected]);
    useEffect(() => {
      if (!loading && !isEmpty(data)) {
        const brandsData = data.brands || [];
        const brandsToShow = getBrandsToShow({
          brands: brandsData,
          brandId,
          legacyId,
          limit
        });
        setBrands(brandsToShow);
        if (onBrandsLoaded) {
          onBrandsLoaded({
            numberOfBrandsDisplayed: brandsToShow.length,
            numberOfBrands: brandsData.length
          });
        }
      }
    }, [data, loading, brandId, legacyId, limit, onBrandsLoaded]);
    useEffect(() => {
      if (hasBrands && isSelecting && !selectedBrandId) {
        resetToFirstExisting();
      }
    }, [hasBrands, isSelecting, resetToFirstExisting, selectedBrandId]);
    const onBrandSavedHook = useCallback(
      (brandData) => {
        setCreatedBrand(brandData == null ? void 0 : brandData.data);
        onBrandSelected(brandData);
      },
      [onBrandSelected]
    );
    if (error) {
      onBrandSelected({ error });
      return /* @__PURE__ */ jsx(Alert, { tone: "critical", children: /* @__PURE__ */ jsx(Text, { children: t("Oops, something went wrong") }) });
    }
    if (loading) {
      return /* @__PURE__ */ jsx(Loader, {});
    }
    const selectCreatedBrand = () => {
      if (createdBrand) {
        onBrandSelected({ data: { ...createdBrand, position: 0 } });
      }
    };
    const createNewBrandProps = {
      setCreatedBrand,
      onBrandSelected,
      onBrandSavedHook,
      getToken,
      isProd,
      showCoverImageText,
      coverPlaceholderText,
      onAddLogoClick,
      onReplaceLogoClick,
      onNewBrandUpdated,
      onAddCoverClick,
      onCoverImageSaved,
      onReplaceCoverClick,
      onRepositionCoverClick,
      onRemoveCoverClick,
      onCoverImageUploadSuccess,
      onCoverImageUploadFailed,
      showCoverImage,
      showBrandId,
      showName,
      showAddCoverImageButton
    };
    const topText = () => {
      if (descriptionAtTop) {
        return descriptionAtTop;
      }
      if (hasBrands) {
        return t(
          "Continue with a previously created brand or create a new one"
        );
      }
      if (showCoverImageText) {
        return t("Create your first brand by uploading your company logo");
      }
      return t(
        "Create your first brand by uploading your company logo. Cover images can be added from the success page, after payment"
      );
    };
    return /* @__PURE__ */ jsx(Box, { background: "surface", children: /* @__PURE__ */ jsxs(Stack, { space: "large", children: [
      /* @__PURE__ */ jsx(Text, { tone: "secondary", children: topText() }),
      hasBrands ? /* @__PURE__ */ jsx(
        BxTabs,
        {
          tabs: [
            {
              PanelContent: /* @__PURE__ */ jsx(
                BrandSelectPanel,
                {
                  ...{
                    brands,
                    setSelectedBrandId,
                    onBrandSelected,
                    selectedBrandId,
                    showCoverImage,
                    showBrandId,
                    showName,
                    tileRowCount,
                    coverPlaceholderText
                  }
                }
              ),
              onClick: () => {
                setIsSelecting(!isSelecting);
                resetToFirstExisting();
                if (onSelectBrandTabClick) {
                  onSelectBrandTabClick();
                }
              },
              text: t("Existing brands")
            },
            {
              PanelContent: /* @__PURE__ */ jsx(CreateBrandPanel, { ...createNewBrandProps, ref }),
              onClick: () => {
                setIsSelecting(!isSelecting);
                selectCreatedBrand();
                if (onCreateBrandTabClick) {
                  onCreateBrandTabClick();
                }
              },
              text: t("Create a new brand")
            }
          ]
        }
      ) : /* @__PURE__ */ jsx(CreateBrandPanel, { ...createNewBrandProps, ref })
    ] }) });
  }
);
const UploadAssetButton = ({
  label,
  dataTestId = "bx-upload-asset",
  allowMultiple = false,
  onFileSelected
}) => /* @__PURE__ */ jsxs(Box, { position: "relative", children: [
  /* @__PURE__ */ jsxs(Button, { variant: "ghost", children: [
    /* @__PURE__ */ jsx(IconImage, {}),
    " ",
    label
  ] }),
  /* @__PURE__ */ jsx(
    FileUploader,
    {
      dataTestId,
      onFileSelected,
      allowMultiple
    }
  )
] });
const delayPromise = async (ms) => new Promise((resolve) => {
  setTimeout(resolve, ms);
});
const retry = async (promiseFn, attempts, waitInMs) => {
  const tryFn = async (attempt) => {
    try {
      return await promiseFn(attempt);
    } catch (error) {
      if (attempt >= attempts) {
        throw error;
      }
      await delayPromise(waitInMs);
      return tryFn(attempt + 1);
    }
  };
  return tryFn(1);
};
const UploadImageButton = ({
  label,
  dataTestId = "bx-upload-image",
  shouldDisplayIconAdd = false,
  maxFileSize = FILE_SIZE_LIMIT,
  isProd = false,
  getToken,
  onImageSelected,
  onImageSizeInvalid,
  onImageTypeInvalid,
  onImageUploadFailed,
  onImageUploadSuccess
}) => {
  const client = useApolloClient();
  const isImagePublished = async (id) => {
    try {
      const { data } = await client.query({
        fetchPolicy: "no-cache",
        query: IsImagePublishedQuery,
        variables: {
          imageId: id
        }
      });
      if (data == null ? void 0 : data.isImagePublished) {
        return true;
      }
    } catch {
      if (onImageUploadFailed) {
        onImageUploadFailed();
      }
    }
    throw new Error("Processing images");
  };
  const uploadImage = async (file) => {
    try {
      const imageUpload = await uploadAsset({
        image: file,
        isProd,
        getToken
      });
      const { id, url } = imageUpload;
      const published = await retry(() => isImagePublished(id), 10, 1e3);
      if (published && onImageUploadSuccess) {
        onImageUploadSuccess(url);
      }
      if (!published && onImageUploadFailed) {
        onImageUploadFailed();
      }
    } catch {
      if (onImageUploadFailed) {
        onImageUploadFailed();
      }
    }
  };
  const onFileSelected = (file) => {
    if (file.size > maxFileSize && onImageSizeInvalid) {
      onImageSizeInvalid();
      return;
    }
    if (!isImageTypeSupported(file.name) && onImageTypeInvalid) {
      onImageTypeInvalid();
      return;
    }
    if (onImageSelected) {
      onImageSelected();
    }
    uploadImage(file);
  };
  return /* @__PURE__ */ jsxs(Box, { position: "relative", children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "ghost",
        icon: shouldDisplayIconAdd ? /* @__PURE__ */ jsx(
          IconAdd,
          {
            data: {
              testid: "icon-add"
            }
          }
        ) : void 0,
        children: label
      }
    ),
    /* @__PURE__ */ jsx(FileUploader, { dataTestId, onFileSelected })
  ] });
};
const tealium = adapter();
function trackCarouselNavigation(payload, linkTextArg) {
  var _a;
  tealium.link("carousel_navigation_pressed", {
    brand: payload == null ? void 0 : payload.brand,
    currentPage: payload == null ? void 0 : payload.currentPage,
    isLoggedIn: payload == null ? void 0 : payload.isLoggedIn,
    siteCountry: (_a = payload == null ? void 0 : payload.siteCountry) == null ? void 0 : _a.toLowerCase(),
    siteLanguage: payload == null ? void 0 : payload.siteLanguage,
    loginId: payload == null ? void 0 : payload.loginId,
    zone: payload == null ? void 0 : payload.zone,
    experiments: payload == null ? void 0 : payload.experiments,
    siteSection: payload == null ? void 0 : payload.siteSection,
    carouselSection: payload == null ? void 0 : payload.carouselSection,
    linkText: linkTextArg
  });
}
const buildUrlWithQueryParams = ({
  relativeUrl,
  analyticsQueryParams,
  language,
  zone
}) => {
  const countrySiteName = getSiteFromZoneAndProduct(zone, "candidate");
  const resolveUrl = createUrlResolver({
    site: countrySiteName,
    language
  });
  const parsedUrl = new URL(relativeUrl, "http://dummy.base");
  const searchParams = new URLSearchParams(analyticsQueryParams);
  searchParams.forEach((value, key) => {
    parsedUrl.searchParams.append(key, value);
  });
  parsedUrl.pathname = parsedUrl.pathname.replace(/\/$/, "");
  return resolveUrl({
    // Convert back to relative URL (remove protocol, hostname, and port)
    path: `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`,
    language
  });
};
const DEFAULT_LANGUAGE = "en";
const DEFAULT_MELWAYS_ZONE = "anz-1";
const getLanguage = ({
  language,
  melwaysZone
}) => !language || melwaysZone === DEFAULT_MELWAYS_ZONE ? DEFAULT_LANGUAGE : language;
const getMelwaysZone = (zone) => zone && isMelwaysZone(zone) ? zone : DEFAULT_MELWAYS_ZONE;
const WriteAReviewButton = ({
  writeAReviewUrl,
  payload
}) => {
  const { t } = useTranslations(translations);
  const tealium2 = adapter();
  return /* @__PURE__ */ jsx(
    ButtonLink,
    {
      icon: /* @__PURE__ */ jsx(IconEdit, {}),
      tone: "formAccent",
      variant: "solid",
      href: writeAReviewUrl,
      onClick: async () => {
        tealium2.link("company_profile_write_review_pressed", {
          siteCountry: payload == null ? void 0 : payload.siteCountry,
          siteLanguage: payload == null ? void 0 : payload.siteLanguage,
          zone: payload == null ? void 0 : payload.zone,
          isLoggedin: payload == null ? void 0 : payload.isLoggedIn,
          siteSection: payload == null ? void 0 : payload.siteSection,
          loginId: payload == null ? void 0 : payload.loginId,
          actionOrigin: "home"
        });
        await new Promise((resolve) => setTimeout(resolve, 500));
      },
      children: t("Write a review")
    }
  );
};
const ReviewsLandingPageHeader = ({
  writeAReviewUrl
}) => {
  const { t } = useTranslations(translations);
  return /* @__PURE__ */ jsxs(Columns, { space: "none", collapseBelow: "desktop", children: [
    /* @__PURE__ */ jsx(Column, { children: /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
      /* @__PURE__ */ jsx(Heading, { level: "3", weight: "regular", component: "h2", children: t("Explore companies") }),
      /* @__PURE__ */ jsx(Text, { size: "standard", weight: "regular", tone: "neutral", children: t(
        "Learn about new jobs, reviews, company culture, perks and benefits."
      ) })
    ] }) }),
    /* @__PURE__ */ jsx(Column, { width: "content", children: /* @__PURE__ */ jsx(Hidden, { below: "desktop", children: /* @__PURE__ */ jsx(WriteAReviewButton, { writeAReviewUrl }) }) })
  ] });
};
const DefaultHeader = ({
  featureFlags = {}
}) => {
  const { t } = useTranslations(translations);
  return /* @__PURE__ */ jsxs(Stack, { space: "small", children: [
    /* @__PURE__ */ jsx(
      Heading,
      {
        level: featureFlags.homepageLayoutRefresh ? "4" : "3",
        weight: featureFlags.homepageLayoutRefresh ? "weak" : void 0,
        component: featureFlags.homepageLayoutRefresh ? "h4" : "h2",
        children: t("Find your next employer")
      }
    ),
    !featureFlags.homepageLayoutRefresh && /* @__PURE__ */ jsx(Text, { tone: "secondary", children: t(
      "Explore company profiles to find the right workplace for you. Learn about jobs, reviews, company culture, perks and benefits."
    ) })
  ] });
};
const Header = ({
  onReviewsLandingPage,
  writeAReviewUrl,
  featureFlags
}) => onReviewsLandingPage ? /* @__PURE__ */ jsx(ReviewsLandingPageHeader, { writeAReviewUrl }) : /* @__PURE__ */ jsx(DefaultHeader, { featureFlags });
const CompanyProfilesQuery = gql`
  query MarqueeCompanies(
    $limit: Int
    $hideReviews: Boolean!
    $hideJobs: Boolean!
    $zone: Zone!
  ) {
    marqueeCompanies(limit: $limit, hideJobs: $hideJobs, zone: $zone) {
      id
      title
      logo
      reviews @skip(if: $hideReviews) {
        rating
        count
      }
      companyNameSlug
      jobCount @skip(if: $hideJobs)
    }
  }
`;
const CompanyProfileCarousel = ({
  analyticsQueryParams,
  onReviewsLandingPage = false,
  writeAReviewUrl = "",
  discoverMoreUrl = "/companies",
  hideReviews = false,
  hideJobs = false,
  onError,
  payload,
  featureFlags = {}
}) => {
  const { t } = useTranslations(translations);
  const numCompanyProfiles = featureFlags.homepageLayoutRefresh ? MAX_ITEMS_FOR_NEW_HOMEPAGE_LAYOUT : MAX_ITEMS;
  const itemPerSlide = featureFlags.homepageLayoutRefresh ? MAX_ITEMS_PER_SLIDE_FOR_NEW_HOMEPAGE_LAYOUT : MAX_ITEMS_PER_SLIDE;
  const { data, error, loading } = useQuery(CompanyProfilesQuery, {
    variables: {
      limit: numCompanyProfiles,
      hideReviews,
      hideJobs,
      zone: payload == null ? void 0 : payload.zone
    },
    ssr: !Boolean(featureFlags.clientQuery)
  });
  const companyProfiles = (data == null ? void 0 : data.marqueeCompanies) ?? [];
  const numberOfCompanies = companyProfiles.length;
  useEffect(() => {
    if (!loading && numberOfCompanies === 0) {
      onError == null ? void 0 : onError("No company profiles found");
    }
  }, [loading, numberOfCompanies, onError]);
  if (error) {
    console.error(error == null ? void 0 : error.message);
    onError == null ? void 0 : onError(error == null ? void 0 : error.message);
    return null;
  }
  if (loading) {
    return /* @__PURE__ */ jsx(
      Placeholder,
      {
        onReviewsLandingPage,
        hideReviews,
        hideJobs,
        featureFlags,
        itemPerSlide,
        numberOfBulletPoints: Math.ceil(numCompanyProfiles / itemPerSlide)
      }
    );
  }
  if (!numberOfCompanies) {
    return null;
  }
  const melwaysZone = getMelwaysZone(payload == null ? void 0 : payload.zone);
  const language = getLanguage({
    language: payload == null ? void 0 : payload.siteLanguage,
    melwaysZone
  });
  const discoverMoreUrlWithQueryParam = buildUrlWithQueryParams({
    relativeUrl: discoverMoreUrl,
    analyticsQueryParams: analyticsQueryParams ?? "",
    language,
    zone: melwaysZone
  });
  const writeAReviewUrlWithQueryParam = `${writeAReviewUrl}${writeAReviewUrl.includes("?") ? "&" : "?"}${analyticsQueryParams}`;
  const sectionSpace = onReviewsLandingPage ? "medium" : "large";
  return /* @__PURE__ */ jsxs(Box, { component: "section", children: [
    /* @__PURE__ */ jsxs(
      Stack,
      {
        space: featureFlags.homepageLayoutRefresh ? "small" : sectionSpace,
        children: [
          /* @__PURE__ */ jsx(
            Header,
            {
              onReviewsLandingPage,
              writeAReviewUrl: writeAReviewUrlWithQueryParam,
              featureFlags
            }
          ),
          /* @__PURE__ */ jsx(
            Carousel,
            {
              companyProfiles,
              onReviewsLandingPage,
              discoverMoreUrl: discoverMoreUrlWithQueryParam,
              showReviews: !hideReviews,
              showJobs: !hideJobs,
              analyticsQueryParams,
              payload,
              itemPerSlide,
              featureFlags
            }
          )
        ]
      }
    ),
    !onReviewsLandingPage ? /* @__PURE__ */ jsx(Box, { paddingTop: { mobile: sectionSpace, desktop: "none" }, children: !featureFlags.homepageLayoutRefresh ? /* @__PURE__ */ jsx(Inline, { space: "none", children: /* @__PURE__ */ jsx(
      ButtonLink,
      {
        variant: "ghost",
        tone: "neutral",
        href: discoverMoreUrlWithQueryParam,
        icon: /* @__PURE__ */ jsx(IconArrow, { direction: "right", alignY: "lowercase" }),
        iconPosition: "trailing",
        onClick: () => {
          trackCarouselNavigation(payload, "See more");
        },
        children: t("See more")
      }
    ) }) : /* @__PURE__ */ jsx(Text, { align: "right", children: /* @__PURE__ */ jsx(
      TextLink,
      {
        href: discoverMoreUrlWithQueryParam,
        icon: /* @__PURE__ */ jsx(IconArrow, { direction: "right" }),
        iconPosition: "trailing",
        weight: "weak",
        onClick: () => {
          trackCarouselNavigation(payload, "See more");
        },
        children: t("See more")
      }
    ) }) }) : /* @__PURE__ */ jsx(Hidden, { above: "tablet", children: /* @__PURE__ */ jsx(Box, { paddingTop: sectionSpace, children: /* @__PURE__ */ jsx(Actions, { children: /* @__PURE__ */ jsx(Inline, { space: "none", children: /* @__PURE__ */ jsx(
      WriteAReviewButton,
      {
        writeAReviewUrl: writeAReviewUrlWithQueryParam,
        payload
      }
    ) }) }) }) })
  ] });
};
const getLogoStrategies = (croppedInfo) => [
  {
    name: StrategiesEnum.JDP_LOGO_LEGACY,
    ...croppedInfo
  },
  {
    name: StrategiesEnum.SERP_LOGO_LEGACY
  },
  {
    name: StrategiesEnum.SERP_LOGO
  },
  {
    name: StrategiesEnum.JDP_LOGO
  }
];
const uploadLogo = async ({
  image,
  getToken,
  isProd,
  croppedInfo
}) => uploadAsset({
  image,
  getToken,
  isProd,
  strategies: getLogoStrategies(croppedInfo),
  usage: Usage.logo
});
export {
  AddAssetButton,
  BrandSelector,
  CompanyProfileCarousel,
  ListBrandsQuery,
  UploadAssetButton,
  UploadImageButton,
  buildUrlWithQueryParams,
  getLanguage,
  getMelwaysZone,
  trackCarouselNavigation,
  uploadLogo
};
